import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ButtonProps } from '../../components/button/types';
import type { AllIconType } from '../../util/types';
import { GLOBAL_ICONS } from '../../util/vars';
import { Button } from '../../components';
import Loader from '../../components/loader/Loader';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {
  icon?: AllIconType,
  children?: string | null,
  showConfirmLabel?: boolean,
  isLoading?: boolean,
}

const NewButton = ({
  children,
  icon = GLOBAL_ICONS.save,
  showConfirmLabel = false,
  isLoading = false,
  ...other
}: Props): JSX.Element => {

  const { translate } = useI18n();

  return (
    <Button
      isOutline
      color={'positive'}
      icon={icon}
      disabled={isLoading}
      {...other}
    >
      {!isLoading
        ? children ?? translate(`components.BUTTONS.${showConfirmLabel ? 'CONFIRM2' : 'SAVE'}`)
        : (<Loader disableLabel smallSize noMargin />)
      }
    </Button>
  );
};

NewButton.displayName = 'NewButton';

export default NewButton;
